// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1om_X","inner":"Footer_inner__1k0p7","nextIcon":"Footer_nextIcon__27_NJ","innerLeft":"Footer_innerLeft__qU1nI"};